import { Drawer, DrawerBody, DrawerContent, DrawerOverlay } from '@chakra-ui/react';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useSuccessPhotoCardToast } from '../../presentation/template/edit-collected-photo-cards/hooks/useSuccessPhotoCardToast';
import { Button } from '@peacecover/component';
import { t } from 'i18next';
import { CheckCircleFill } from '@peacecover/icon';

const GOODS_TYPE_ITEMS = [
  { id: 'base', name: '기본 특전', image: 'Wrapped gift', key: 'base' },
  { id: 'first_come', name: '선착순 특전', image: 'Index pointing up', key: 'firstCome' },
  { id: 'gacha', name: '갓챠 특전', image: 'Four leaf clover', key: 'gacha' },
  { id: 'lucky_draw', name: '럭키드로우', image: 'Four leaf clover', key: 'luckyDraw' },
  { id: 'lucky_number', name: '럭키 넘버', image: 'Four leaf clover', key: 'luckyNumber' },
  { id: 'random', name: '랜덤 특전', image: 'Game die', key: 'random' },
  { id: 'menu', name: '메뉴 특전', image: 'Shortcake', key: 'menu' },
  { id: 'special_day', name: '당일 특전', image: 'Tear-off calendar', key: 'specialDay' },
  { id: 'hashtag', name: '해시태그', image: 'Hash-tag', key: 'hashtag' },
  { id: 'photobooth', name: '포토부스', image: 'clapper_board', key: 'photobooth' },
  { id: 'small_exhibition', name: '미니 전시', image: 'Exhibition', key: 'smallExhibition' }
];

export interface GoodsTypeBottomDrawerProps {
  isOpen: boolean;
  initialSelectedGoodsTypes?: string[];
  onApply: (selected: string[]) => void;
  onClose: () => void;
}

const ReportEventGoodsTypeBottomDrawer: React.FC<GoodsTypeBottomDrawerProps> = ({
  isOpen,
  initialSelectedGoodsTypes = [],
  onApply,
  onClose
}) => {
  const [selectedGoodsTypes, setSelectedGoodsTypes] = useState<string[]>(initialSelectedGoodsTypes);
  const showSuccessPhotoCardToast = useSuccessPhotoCardToast();

  // 초기 선택된 타입들이 변경될 때 상태 업데이트
  useEffect(() => {
    setSelectedGoodsTypes(initialSelectedGoodsTypes);
  }, [initialSelectedGoodsTypes]);

  const selectGoodsType = (id: string) => {
    if (selectedGoodsTypes.includes(id)) {
      setSelectedGoodsTypes(selectedGoodsTypes.filter((type) => type !== id));
      return;
    }

    if (selectedGoodsTypes.length >= 2) {
      showSuccessPhotoCardToast('bottom', t('ReportEventGoodsTypePage.errorMessage') as string, false);
      return;
    }
    const newSelectedTypes = [...selectedGoodsTypes, id];
    setSelectedGoodsTypes(newSelectedTypes);
    onApply(newSelectedTypes);
  };

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
      <DrawerOverlay />
      <DrawerContent className="rounded-t-[20px] z-9999">
        <DrawerBody className="!py-0 !px-[20px] mt-[20px] !pb-[20px]">
          <div className="flex flex-col gap-[4px]">
            {GOODS_TYPE_ITEMS.map((item) => {
              const isSelected = selectedGoodsTypes.includes(item.id);
              return (
                <label
                  key={item.id}
                  className="flex items-center justify-between -mx-[4px] pt-[14px] pb-[13px] border-b border-separator1 last:border-none"
                  htmlFor={item.id}
                >
                  <div className="flex items-center gap-[10px]">
                    <img
                      src={`/assets/icons/graphic-3d/3D.${item.image}.png`}
                      alt={item.name}
                      className="w-[17px] h-[17px]"
                    />
                    <span className="text-[17px] font-medium text-text-main-lv2 leading-none">
                      {t(`ReportEventGoodsTypePage.goodsType.${item.key}`)}
                    </span>
                  </div>
                  <button type="button" onClick={() => selectGoodsType(item.id)} id={item.id}>
                    <CheckCircleFill
                      size={24}
                      backgroundColor={
                        isSelected ? 'var(--color-primary)' : 'var(--color-surface-lv2)'
                      }
                      strokeColor={
                        isSelected ? 'var(--color-on-primary)' : 'var(--color-text-sub-lv2)'
                      }
                    />
                  </button>
                </label>
              );
            })}
          </div>
          <Button
            size="large"
            className="mt-[20px] w-full text-[17px] font-semibold"
            onClick={() => {
              onClose();
            }}
          >
            {t('confirm')}
          </Button>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default ReportEventGoodsTypeBottomDrawer;
